import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AppliedShiftResponse, SearchShiftsQueryRequest, ShiftDetail, ShiftSearchResult, ShiftSettings, WorkSchedule, ShiftOptions } from '../shifts.model';

@Injectable({ providedIn: 'root' })
export class ShiftsHttpService {
    private url = `${environment.url.api}/shift`;
    private http = inject(HttpClient);

    searchShifts(query: SearchShiftsQueryRequest): Observable<ShiftSearchResult> {
        return this.http.post<ShiftSearchResult>(`${this.url}/search`, query);
    }

    getShift(shiftId: string): Observable<ShiftDetail> {
        return this.http.get<ShiftDetail>(`${this.url}/${shiftId}`);
    }

    applyShift(shiftId: string): Observable<AppliedShiftResponse> {
        return this.http.post<AppliedShiftResponse>(`${this.url}/${shiftId}/apply`, {});
    }

    getShiftSettings(): Observable<ShiftSettings> {
        return this.http.get<ShiftSettings>(`${this.url}/usersettings`);
    }

    saveShiftSettings(request: ShiftSettings): Observable<void> {
        return this.http.put<void>(`${this.url}/usersettings`, request);
    }

    getWorkSchedule(): Observable<WorkSchedule> {
        return this.http.get<WorkSchedule>(`${this.url}/work-schedule`);
    }

    saveWorkSchedule(dayId: string, scheduleId: string, isEnabled: boolean): Observable<void> {
        return this.http.put<void>(`${this.url}/work-schedule/day/${dayId}/schedule/${scheduleId}`, { isEnabled });
    }

    getShiftOptions(): Observable<ShiftOptions> {
        return this.http.get<ShiftOptions>(`${this.url}/options`);
    }
}